import uri from './uri'

let config = (RestangularProvider) => {
	RestangularProvider.setBaseUrl(uri);
	// RestangularProvider.setBaseUrl('https://api.sabin.com.br/admin');
	//RestangularProvider.setBaseUrl('https://dev.api.sabin.aisdigital.com.br/admin');
	//RestangularProvider.setBaseUrl('http://localhost:3000/admin');
}

config.$inject = ['RestangularProvider'];

export default config;



// WEBPACK FOOTER //
// ./client/app/config/restangular-config.js